// initial state
const state = {
    user: {
        loggedin: false,
        profile: null
    },
    permissions: [
        'public'
    ],
    isLoading: false
};

// getters
const getters = {
    getUser: state => state.user,
    getUserPermissions: state => state.permissions,
    userHasPermission: (state) => (permission) => {
        return state.permissions.indexOf(permission) !== -1;
    },
    userIsClientAdmin: (state) => {
        return state.user.user_type_id === 2;
    },
    userIsClient: (state) => {
        return state.user.user_type_id === 4;
    },
    userIsProjectManager: (state) => {
        return state.user.user_type_id === 3;
    },
    userIsAdmin: (state) => {
        return state.user.user_type_id === 1;
    },
    // Temporary KI MVP gate — remove with the feature
    userCanAccessKiMvp: (state) => {
        const raw = process.env.VUE_APP_KI_MVP_ALLOWED_ACCOUNT_IDS || '';
        const ids = raw.split(',')
            .map((value) => parseInt(value.trim(), 10))
            .filter((id) => id > 0);
        return ids.indexOf(parseInt(state.user.id, 10)) !== -1;
    },
    isLoading: state => state.isLoading
};

// mutations
const mutations = {
    ['SET_USER'](state, user) {
        state.user = user;
        state.user.loggedin = true;
    },

    ['SET_USER_PERMISSIONS'](state, permissions) {
        let perms = ['public'];
        Object.keys(permissions).forEach(function (key) {
            let permKey = Object.keys(permissions[key])[0];
            perms.push(permKey);
        });
        if (getters.userIsAdmin) {
            perms.push('administrator');
        }
        state.permissions = perms;
    },

    ['RESET_USER'](state) {
        state.user = {
            loggedin: false,
            profile: null
        };
        state.permissions = [
            'public'
        ]
    },

    ['SET_LOADING'](state, loading) {
        state.isLoading = loading;
    },
};

export default {
    state,
    getters,
    mutations
};
